import styled from 'styled-components';

import CardBackground from '../../CoreWrappers/CardBackground';

export default styled(CardBackground)`
	.description {
		color: var(--neutrals-700);
	}
	.motif-text-button {
		pointer-events: none;
		* {
			pointer-events: all;
		}
	}
`;
